import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { Button, Input, Modal } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useAdvanceSearchModalContext } from '../AdvanceSearchModal.hook';
import '../AdvanceSearchModal.styles.scss';
import { tSearchBarHeaderProps } from '../AdvanceSearchModal.types';

export default function SearchBarHeader(props: tSearchBarHeaderProps) {
  const { resetModal } = props;
  const { inputValue, setLoading, setInputValue } =
    useAdvanceSearchModalContext();
  const { t } = useTranslation('navbar/navbar');

  return (
    <Modal.Header className="AdvanceSearchModal__Header">
      <MagnifyingGlassIcon className="w-7 text-primary" />
      <Input
        autoFocus
        color="ghost"
        className="AdvanceSearchModal__Header__Input"
        placeholder={t('advanceSearch.searchPlaceholder')}
        value={inputValue}
        onChange={(e) => {
          const newValue = e.target.value;
          setInputValue(newValue);

          if (newValue.length > 1) setLoading(true);
        }}
      />
      <Button
        shape="circle"
        color="ghost"
        size="sm"
        onClick={() => {
          resetModal();
        }}
      >
        <XMarkIcon className="w-7" />
      </Button>
    </Modal.Header>
  );
}
